import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const ButtonGroupRoot = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'w-fit flex h-fit items-center justify-center gap-1 rounded-md border border-gray-200/70 bg-gray-100 p-1',
      className
    )}
    {...props}
  />
)
